import { takeLatest, put, call } from 'redux-saga/effects';

import { findImplantacaoEstoque } from '../service';
import {
  FIND_IMPLANTACAO_ESTOQUE,
  FIND_IMPLANTACAO_ESTOQUE_PENDING,
  FIND_IMPLANTACAO_ESTOQUE_SUCCESS,
  FIND_IMPLANTACAO_ESTOQUE_FAILURE
} from '../actionTypes';

function* sagaFindImplantacaoEstoque(action) {
  yield put({ type: FIND_IMPLANTACAO_ESTOQUE_PENDING, id: action.id })

  try {

    const registro = yield call(findImplantacaoEstoque, action.id);

    yield put({ type: FIND_IMPLANTACAO_ESTOQUE_SUCCESS, registro: registro })

  } catch (error) {

    yield put({ type: FIND_IMPLANTACAO_ESTOQUE_FAILURE })
    // console.error(error) // eslint-disable-line

  }
}

export default function* watchFindImplantacaoEstoque() {
  yield takeLatest(FIND_IMPLANTACAO_ESTOQUE, sagaFindImplantacaoEstoque)
}
